<div class="govuk-grid-row">
  <div class="govuk-grid-column-three-quarters">
    <span class="govuk-caption-xl govuk-!-margin-bottom-2">{{ workplaceName }}</span>
    <h1 class="govuk-heading-l govuk-!-margin-bottom-8">10% off Skills for Care&apos;s eLearning modules</h1>
    <div class="asc-cms-content" [innerHTML]="pages.content"></div>
  </div>
</div>
